import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/sdmswork/Documents/Fydo/backend/Fydo-Event-Website/src/app/[eventId]/buy-page/components/buyTicketSection/buyTicketSection.component.tsx");
